import React, { useLayoutEffect, useState, useEffect } from 'react'
import DataGrid, {
    Column,
    Export,
    HeaderFilter,
    Pager,
    Paging,
    SearchPanel,
} from "devextreme-react/data-grid";
import Popup from "devextreme-react/popup";
import { Button, SelectBox, CheckBox } from "devextreme-react";
import TextArea from "devextreme-react/text-area";
import { TagBox } from 'devextreme-react/tag-box';
import Swal from 'sweetalert2';
import { IOMConfigurationService } from '../../../apis/apiServices/IOMConfiguration'
import { DesignationService } from '../../../apis/apiServices/Designation'
import { getUserByDesignationId } from '../../../apis/apiServices/User'
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

export default function IOMConfigurationComponent() {
    useLayoutEffect(() => {
        document.querySelector("#pageTitle").innerHTML = "IOM Approvers";
        getIOMConfigurationList();
        getDesignationDropdownData();
    }, []);

    const navigate = useNavigate();
    const [IOMConfigurationList, setIOMConfigurationList] = useState(null);
    const [designationList, setDesignationList] = useState(null);
    const [userByDesignationList, setUserByDesignationList] = useState(null);
    const [isIOMApproverModalOpen, setIsIOMApproverModalOpen] = useState(false);
    const [IomApprover, setIomApprover] = useState({
        approvalConfigurationId: 0,
        designationId: "",
        UserIds: [],
        isActive: true,
    });
    const [errors, setErrors] = useState({});

    const getIOMConfigurationList = async () => {
        try {
            const response = await IOMConfigurationService.getIOMConfigurationList()
            setIOMConfigurationList(response?.data);
        } catch (error) {
            console.log("Error getIOMConfigurationList===>", error);
        }
    }

    const getDesignationDropdownData = async () => {
        try {
            const response = await DesignationService.getDesignationList()
            setDesignationList(response?.data);
        } catch (error) {
            console.log("Error getDesignationDropdownData===>", error);
        }
    }

    const getUserByDesignation = async (desgnationId) => {
        try {
            const response = await getUserByDesignationId(desgnationId)
            setUserByDesignationList(response);
        } catch (error) {
            console.log("Error getDesignationDropdownData===>", error);
        }
    }



    useEffect(() => {
        getIOMConfigurationList();
    }, [])

    const openModal = () => {
        setIomApprover({
            designationId: 0,
            approvalConfigurationId: 0,
            UserIds: [],
            isActive: true,
        });
        setIsIOMApproverModalOpen(true);
    };

    const handleSubmit = async () => {


        const newErrors = {};
        if (!IomApprover?.designationId) newErrors.designationId = "Please select designation";
        if (!IomApprover?.UserIds.length) newErrors.UserIds = "Please select users";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            //setIsSubmitted(false);
            return;
        }
        let body = {
            designationId: IomApprover?.designationId,
            userIds: IomApprover?.UserIds || 0,
            isRecommended: true,
            //ModifiedBy: user.userId,
        };

        const response = await IOMConfigurationService.addIOMConfiguration(body);

        if (!response?.isSuccess) {
            Swal.fire(
                "",
                `${response?.message}`,
                "error"
            );
            return;
        }
        setIsIOMApproverModalOpen(false)
        Swal.fire(
            "",
            `${response?.message}`,
            "success"
        ).then(() => { navigate(`/inter-office-memo-configuration`) });
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "",
            text: "Are you sure, you want to remove selected designation from approver list?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        });

        if (!result.isConfirmed) return;

        // Proceed with delete API
        const body = [id];

        const response = await IOMConfigurationService.deleteIOMApprovalConfiguration(body);

        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.message}`,
                "error"
            );
            return;
        }

        Swal.fire(
            "",
            `${response?.message}`,
            "success"
        ).then(() => {
            navigate(`/inter-office-memo-configuration`);
            //navigate("/inter-office-memo-configuration")
        });
    };


    const handleFormData = (key, value) => {
        setIomApprover((prevState) => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }

    const openEditModal = (rowData) => {

        let selectedUserIds = (IOMConfigurationList?.filter(row => row?.designationId === rowData?.designationId))?.map(userRow => userRow?.userId)

        setIomApprover({
            designationId: rowData?.designationId,
            approvalConfigurationId: rowData?.approvalConfigurationId,
            UserIds: selectedUserIds || [],
            isActive: rowData?.isActive,
        });
        setIsIOMApproverModalOpen(true);
    };

    useEffect(() => {
        let selectedUserIds = (IOMConfigurationList?.filter(row => row?.designationId === IomApprover?.designationId))?.map(userRow => userRow?.userId)

        setIomApprover(prevState => {
            return {
                ...prevState,
                UserIds: selectedUserIds || [],
            }
        });
    }, [IomApprover?.designationId])

    return (<>
        <div className="content">
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            {/* <div>
                                <Link to={"/new-IOMConfiguration"}>
                                    <button className="btn btn-primary btn-sm" title='Add'>
                                        <i className="fas fa-plus"></i> Add
                                    </button></Link>
                            </div> */}
                            <DataGrid
                                dataSource={IOMConfigurationList}
                                columnAutoWidth={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={true}
                                allowColumnResizing={false}
                                columnHidingEnabled={true}
                                onToolbarPreparing={(e) => {
                                    e.toolbarOptions.items.unshift({
                                        location: "before",
                                        widget: "dxButton",
                                        options: {
                                            icon: "plus",
                                            text: "Add",
                                            type: "default",
                                            stylingMode: "contained",
                                            onClick: () => openModal(),
                                            hint: "Add",
                                        }
                                    });
                                }}
                            >
                                <Column width="70px" caption={""} cellRender={(cellData) => {
                                    return <>
                                        <span title='Delete'>
                                            <Icon className='iconify-size' title="Delete" tooltip="Delete" icon="fluent:delete-32-regular" style={{ cursor: 'pointer' }}
                                                onClick={(e) => {
                                                    const rowData = cellData?.data;
                                                    handleDelete(rowData?.approvalConfigurationId);
                                                }}
                                            />
                                        </span>
                                        &nbsp;
                                        &nbsp;
                                        <span title="Edit">
                                            <Icon
                                                title="Edit"
                                                className='iconify-size mr-1'
                                                icon="solar:pen-line-duotone"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() =>
                                                    openEditModal(cellData?.data)
                                                }
                                            />
                                        </span>
                                    </>

                                }}>
                                </Column>
                                <Column dataField="designationName" caption="Designation" />
                                <Column dataField="displayName" caption="Display Name" />
                                <Column dataField="departmentName" caption="Department" />
                                <Column dataField="userName" caption="Name" />
                                {/* <Column dataField="isRecommended" caption="IsApproval" /> */}
                                <HeaderFilter visible={false} />
                                <SearchPanel
                                    visible={true}
                                    highlightCaseSensitive={true}
                                    width={200}
                                    placeholder="Search..."
                                />
                                <Paging defaultPageSize={15} />
                                <Pager
                                    visible={true}
                                    allowedPageSizes={[10, 15, 20, 50, 100]}
                                    showPageSizeSelector={true}
                                    showInfo={true}
                                    showNavigationButtons={true}
                                />
                                <Export enabled={true} fileName="Vendors" />
                            </DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Popup
            visible={isIOMApproverModalOpen}
            onHiding={() => setIsIOMApproverModalOpen(false)}
            dragEnabled={false}
            showTitle={true}
            title={IomApprover?.approvalConfigurationId ? "Update Approver" : "Add Approver"}
            height="auto"
            weight="auto"
            className='custom-modal-popup'
        >
            <div className='popup-body'>
                <div className='form-group'>
                    <label>Designation <span className="text-danger">*</span></label>
                    <div>
                        <SelectBox
                            dataSource={designationList}
                            valueExpr="id"
                            displayExpr="name"
                            className="form-control"
                            placeholder="Select designation"
                            searchEnabled
                            showClearButton={true}
                            value={IomApprover?.designationId}
                            onValueChanged={(e) => {
                                handleFormData("designationId", e?.value);
                                getUserByDesignation(e.value);
                            }}
                        />
                        {errors?.designationId && (
                            <div className="error invalid-feedback">{errors?.designationId}</div>
                        )}
                    </div>
                </div>
                <div className='form-group'>
                    <label>User <span className="text-danger">*</span></label>
                    <div>
                        <TagBox
                            dataSource={userByDesignationList}
                            valueExpr="id"
                            displayExpr="name"
                            className="form-control"
                            placeholder="Select user"
                            searchEnabled={true}
                            multiline={true}
                            showSelectionControls={true}
                            showClearButton={true}
                            applyValueMode="useButtons"
                            height={200}
                            value={IomApprover?.UserIds || []} // This should be an array of selected IDs
                            onValueChanged={(e) => handleFormData("UserIds", e.value)} // Store all selected IDs
                        />
                        {errors?.UserIds && (
                            <div className="error invalid-feedback">{errors?.UserIds}</div>
                        )}
                    </div>
                </div>
                {/* <div className='form-group'>
                    <CheckBox
                        value={IomApprover?.isActive}
                        onValueChanged={(e) => handleFormData("isActive", e?.value)}
                    />
                    <label style={{ margin: 3 }}> Is Active</label>
                </div> */}
            </div>
            <div className='text-right'>
                <Button icon='close'
                    text="Cancel"
                    onClick={() => {
                        setIsIOMApproverModalOpen(false);
                        setIomApprover("");
                        setErrors("");
                    }}
                    stylingMode="outlined"
                    className="btn btn-outline-primary btn-sm mr-2"
                />
                <Button
                    icon='check'
                    text="Submit"
                    type="success"
                    onClick={handleSubmit}
                    className="btn btn-primary btn-sm"
                />
            </div>
        </Popup>
    </>
    )
}

